import React from 'react';
import { Label } from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { ReportingOption } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { CookbookRadioWrapper } from 'src/components/CookbookRadioWrapper/CookbookRadioWrapper';

export interface ReportingRequirementControlProps {
  name: string;
  id: string;
}

export function ReportingRequirementControl({
  name,
  id,
}: ReportingRequirementControlProps): JSX.Element {
  const { control } = useFormContext();
  return (
    <>
      <Label aria-label="ReportingRequirementControl" inputSize="medium">
        Reporting Requirement
      </Label>
      <CookbookRadioWrapper
        name={name}
        id={`${id}${ReportingOption.NONE_REPORTING_OPTION}`}
        control={control}
        label="Others"
        value={ReportingOption.NONE_REPORTING_OPTION}
      />
      <CookbookRadioWrapper
        name={name}
        id={`${id}${ReportingOption.LOCATIONS_REPORTING_OPTION}`}
        control={control}
        label="Locations"
        value={ReportingOption.LOCATIONS_REPORTING_OPTION}
      />
      <CookbookRadioWrapper
        name={name}
        id={`${id}${ReportingOption.DEPARTMENTS_REPORTING_OPTION}`}
        control={control}
        label="Departments"
        value={ReportingOption.DEPARTMENTS_REPORTING_OPTION}
      />
    </>
  );
}
